import MessageSetting from './MessageSetting';
import './style/index.less';

export default MessageSetting;
